import i18n from '@/i18n'

export default [
    { value: false, text: i18n.t('checkIn.blockCheckins'), isDefault: false },
    { value: true, text: i18n.t('checkIn.unblockCheckins'), isDefault: true },
]
